
export default {
  name: 'Features',
  props: {
    text: {
      type: String,
      require: false,
    },
    image: {
      type: Object,
      require: false,
    },
    reverse: {
      type: Boolean,
      default: false,
    },
  },
}
